<div
  class="multi-select-container"
  [ngClass]="{ light: isLight, dark: !isLight }"
  (clickOutside)="handleClickOutside()"
>
  <div class="selected-items">
    @for (item of selectedItems; track item) {
      <div class="item-chip">
        <span>{{ item[displayField] | translate }}</span>
        <button type="button" class="remove-btn" (click)="removeItem(item)">&times;</button>
      </div>
    }
    <input
      type="text"
      [formControl]="searchControl"
      [placeholder]="placeholder | translate"
      (focus)="toggleDropdown()"
      [ngClass]="{ light: isLight, dark: !isLight }"
    />
  </div>

  @if (isDropdownOpen) {
    <div class="dropdown">
      @if (isLoading) {
        <div class="loading">{{ 'COMMON.LOADING' | translate }}</div>
      }
      @if (errorMessage) {
        <div class="error">{{ errorMessage }}</div>
      }
      @for (option of filteredOptions; track option) {
        <div
          class="dropdown-item"
          (click)="selectItem(option)"
          (keydown.enter)="selectItem(option)"
          tabindex="0"
          role="button"
        >
          {{ option[displayField] | translate }}
          @if (option.billingCity || option.billingCountry) {
            <small> ({{ option.billingCity }} {{ option.billingCountry }}) </small>
          }
        </div>
      }
      @if (!isLoading && filteredOptions.length === 0) {
        <div class="no-results">
          {{ 'COMMON.NO_RESULTS_FOUND' | translate }}
        </div>
      }
    </div>
  }
</div>
